import { render, staticRenderFns } from "./LegendAction.vue?vue&type=template&id=f4a467c0&scoped=true"
import script from "./LegendAction.vue?vue&type=script&lang=js"
export * from "./LegendAction.vue?vue&type=script&lang=js"
import style0 from "./LegendAction.vue?vue&type=style&index=0&id=f4a467c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.11.0_webpack@5.108.4__lodash@4.18.1_v_a2207b490383b17cb9602cac89392a43/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a467c0",
  null
  
)

export default component.exports